module.exports = global["moment"] = require("-!./moment.js");